import AddCreditCardButton from 'components/FrictionlessCheckout/PaymentReleaseFour/CreditCard/AddCreditCardButton/AddCreditCardButton';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { connect } from 'react-redux';
import PaymentEN from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_en_US';
import PaymentFR from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_fr_CA';

const { wrapHOC } = FrameworkUtils;

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentEN, PaymentFR);

const localizationSelector = createStructuredSelector({
    addNewCard: getTextFromResource(getText, 'addNewCard'),
    debitCardDisclaimer: getTextFromResource(getText, 'debitCardDisclaimer')
});

const fields = createSelector(
    localizationSelector,
    (_ownState, ownProps) => ownProps.isZeroCheckout,
    localization => {
        const isCanada = LanguageLocaleUtils.isCanada();

        return {
            label: localization.addNewCard,
            debitCardDisclaimer: localization.debitCardDisclaimer,
            isCanada
        };
    }
);

const withPaymentProps = wrapHOC(connect(fields, null));

export default withPaymentProps(AddCreditCardButton);
